import { Link } from '@tanstack/react-router';
import type { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/DataTable';
import { Text } from '@/components/Typography/Text';
import { cn } from '@/lib/cn';
type Item = {
  contractId: string;
  contractNo: string | null;
};
export const contractNoColumn = <T extends Item,>(): ColumnDef<T> => ({
  id: 'contractNo',
  accessorKey: 'contractNo',
  meta: {
    i18nKey: 'contractNo',
    thStyle: {
      minWidth: '150px'
    }
  },
  header: DataTableColumnHeader,
  cell: ({
    row
  }) => {
    return <Link to="/contract/$id" params={{
      id: row.original.contractId
    }} className={cn('hover:underline')}>
        <Text variant="tableItem" className="text-inherit">
          {row.original.contractNo ?? '-'}
        </Text>
      </Link>;
  },
  enableSorting: true,
  sortingFn: 'alphanumeric'
});